import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { hostnameOf, isPlaceholderUrl } from "./sourceUrl";

const MAX_SUGGESTION_CHARS = 48;

function truncate(value: string, max = MAX_SUGGESTION_CHARS): string {
  return value.length > max ? `${value.slice(0, max - 1)}…` : value;
}

interface SourceUrlCellProps {
  url: string | null;
  suggestedUrl: string | null;
  showSuggestion: boolean;
  /** Rendered only when the row can be edited and the form is not already open. */
  onUseSuggested: (() => void) | null;
}

const SourceUrlCell = ({
  url,
  suggestedUrl,
  showSuggestion,
  onUseSuggested,
}: SourceUrlCellProps) => {
  return (
    <>
      {isPlaceholderUrl(url) ? (
        <span className="text-muted-foreground">No site found</span>
      ) : (
        <a
          href={url as string}
          target="_blank"
          rel="noopener noreferrer"
          title={url as string}
          className="inline-flex items-center gap-1 text-primary-text hover:underline"
        >
          {hostnameOf(url as string)}
          <ExternalLink className="h-3 w-3 shrink-0" />
        </a>
      )}
      {showSuggestion && suggestedUrl ? (
        <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
          <span>
            Suggested:{" "}
            <span className="break-all" title={suggestedUrl}>
              {truncate(suggestedUrl)}
            </span>
          </span>
          {onUseSuggested ? (
            <Button
              size="sm"
              variant="link"
              className="h-auto p-0 text-xs"
              onClick={onUseSuggested}
            >
              Use suggested
            </Button>
          ) : null}
        </div>
      ) : null}
    </>
  );
};

export default SourceUrlCell;
